import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { TimezoneService } from '../../services/timezone.service';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  private readonly DATE_TIME_FORMAT = 'DD/MM/YY, HH:mm:ss';
  private readonly DATE_TIME_FORMAT_TZ = 'DD/MM/YY, HH:mm:ss Z';

  constructor(private timezoneService: TimezoneService) {}

  transform(value: number, args?: any): string {
    if (!value) { return ''; }
    if (args?.customFormat) {
      return moment(value).tz(this.timezoneService.getCurrentTimezone()).format(args.customFormat);
    } else {
      return moment(value).tz(this.timezoneService.getCurrentTimezone())
        .format(args?.showTimezone ? this.DATE_TIME_FORMAT_TZ : this.DATE_TIME_FORMAT);
    }
  }

}
